import { gql } from '@apollo/client';
import Fragments from './fragments';

export const AUTOMATIC_USER_ALLOCATIONS_QUERY = gql`
  query automaticUserAllocations {
    automaticUserAllocations {
      automaticUserAllocationId
      dealerId
      dealerName
      userId
      userName
      offerResponsibleId
      offerResponsibleName
      offerInsuranceUserId
      offerInsuranceUserName
      offerAccountManagerId
      offerAccountManagerName
      allUsers
    }
  }
`;

export const DEALERS_QUERY = gql`
  query dealers($search: String) {
    dealers(search: $search) {
      dealerId
      name
      registrationCode
    }
  }
`;

export const RESPONSIBLES_QUERY = gql`
  query responsibles {
    responsibles {
      responsibleId
      name
      email
    }
  }
`;

export const ALLOCATION_RESPONSIBLES_QUERY = gql`
  query automaticUserAllocationsResponsiblesByUserGroups {
    automaticUserAllocationsResponsiblesByUserGroups {
      salesResponsibles {
        ...person
      }
      asmResponsibles {
        ...person
      }
      insuranceResponsibles {
        ...person
      }
    }
  }
  ${Fragments.person}
`;

export const ERPUSERS_QUERY = gql`
  query ERPUsers {
    ERPUsers {
      userId
      userName
      partnerId
      personId
    }
  }
`;
